import { format } from 'date-fns'

export default {
    reportsShiftSummaries: [],
    reportsShiftSummariesLoading: false,
    detailedReports: [],
    detailedReportsLoading: false,
    machines: [],
    statusNames: null,
    taskNames: null,
    reportShiftSummaryStatuses: [],
    reportShiftSummaryGroups: [],
    userDetailedReports: [],
    userDetailedReportsLoading: false,
    detailedShipmentsReports: [],
    detailedShipmentsReportsLoading: false,
    codeCompliancesList: [],

    detailedReportsFilters: setInitialDetailedReportsFilters(),
    setInitialDetailedReportsFilters: setInitialDetailedReportsFilters,

    reportsShiftSummariesFilters: setInitialReportsShiftSummariesFilters(),
    setInitialReportsShiftSummariesFilters: setInitialReportsShiftSummariesFilters,

    userReportsShiftSummariesFilters: setInitialUserReportsShiftSummariesFilters(),
    setInitialUserReportsShiftSummariesFilters: setInitialUserReportsShiftSummariesFilters,

    detailedShipmentsReportsFilters: setInitialDetailedShipmentsReportsFilters(),
    setInitialDetailedShipmentsReportsFilters: setInitialDetailedShipmentsReportsFilters,

    codeCompliancesListFilters: setInitialCodeCompliancesListFilters(),
    setInitialCodeCompliancesListFilters: setInitialCodeCompliancesListFilters,
}

function setInitialDetailedReportsFilters() {
    return {
        reportShiftSummary_id: null,
        search: null
    }
}

function setInitialReportsShiftSummariesFilters() {
    return {
        status_id: 10, //Zakończony
        startDateTime__lte: null,
        startDateTime__gte: null,
        user_id: null,
        group_id: null,
        productionSiteGroup_ids: [],
        productionSite_id: null
    }
}

function setInitialUserReportsShiftSummariesFilters() {
    return {
        startDateTime__lte: format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY-MM-DD'),
        startDateTime__gte: null,
        user_id: null,
        group_id: null,
        productionSiteGroup_id: null
    }
}

function setInitialDetailedShipmentsReportsFilters() {
    return {
        shipmentReportShiftSummary_id: null,
        search: null
    }
}

function setInitialCodeCompliancesListFilters() {
    return {
        orderNumber: null
    }
}
